var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner1X10S200Px200Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.9166666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.8333333333333334s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.75s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.6666666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5833333333333334s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.4166666666666667s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.3333333333333333s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.25s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.16666666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "-0.08333333333333333s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#c9c6c7",
    height: 12,
    width: 6,
    ry: 6,
    rx: 3,
    y: 24,
    x: 47
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    values: "1;0",
    attributeName: "opacity"
  }))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner1X10S200Px200Px);
export default __webpack_public_path__ + "static/media/Spinner@1x-1.0s-200px-200px.cdf20ce5ad7cb6be7d1ae8628ebe57b5.svg";
export { ForwardRef as ReactComponent };